<ng-container *ngIf="notification">
    <section class="notification">
        <div class="notification__header">
            <button mat-icon-button class="notification__header-close" (click)="closeNotification()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="notification__content">
            <mat-icon class="notification__content-icon material-symbols-outlined">notifications</mat-icon>

            <div class="notification__content-text">
                <span class="notification__content-text--highlight">New Service Request</span>
                <span>
                    Service request created by {{ notification.customerName }}

                    <ng-container *ngIf="timezone$ | async as timezone; else mstTimeTemplate">
                        at {{ notification.createdOn | convertDate: timezone | date: HOUR_MINUTE_FORMAT }}
                        {{ timezone.shortName | timezoneAbbreviation }}
                    </ng-container>

                    <ng-template #mstTimeTemplate> at {{ notification.createdOn | date: HOUR_MINUTE_FORMAT }} MST </ng-template>
                </span>
            </div>
        </div>

        <div class="notification__actions">
            <a
                mat-ripple
                class="btn-dark flex-center notification__actions-view"
                aria-label="View Service Request"
                (click)="onViewServiceRequest()"
            >
                View
            </a>
            <button mat-ripple class="btn-light" (click)="closeNotification()">Dismiss</button>
        </div>
    </section>
</ng-container>
